var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutorotatePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0188 27.2062L13.9419 23.1295L18.0188 19.0527L18.9311 19.965L15.7663 23.1295L18.9311 26.294L18.0188 27.2062Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 24H14.8541V22.222H15.5C23.8716 22.222 29.7084 18.9443 29.7084 16C29.7084 13.0553 23.8716 9.77767 15.5 9.77767C7.12845 9.77767 1.29159 13.0553 1.29159 16C1.29159 18.4222 5.37661 21.3887 12.2063 22.1556L12.1013 23.9333C6.07881 23.2555 0 20.5443 0 16C0 10.7998 7.98415 8 15.5 8C23.0159 8 31 10.7998 31 16C31 21.1999 23.0159 24 15.5 24Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutorotatePlay);
export default __webpack_public_path__ + "static/media/autorotatePlay.908f385a196c100b970238a02ecb7308.svg";
export { ForwardRef as ReactComponent };